const CustomerBanner = () => {
  return (
    <div className="bg-[#EFF9FE] p-4 flex flex-col w-full text-black">
      <div className={` md:mx-16`}>
        <div className="text-center text-[25px] leading-[59.524%] font-HNmed pt-6 pb-4">
          TRUSTED BY COMPANIES
        </div>
        <div className="text-black text-center text-[15px] not-italic font-HNlight leading-[114%] md:px-[25%]">
          Count on us to deliver trusted solutions and services, as we have
          earned the confidence of numerous industry-leading companies.
        </div>
        <div className="flex flex-wrap md:flex-row md:mx-4 mb-12 mt-8 mx-6 justify-evenly items-center">
          <img
            className="max-h-12 m-4 "
            src={require("../../assets/images/customers/kpnamboodiris.png")}
            alt="KPNamboodiri"
          />
          <img
            className="max-h-24 mx-6"
            src={require("../../assets/images/customers/avs-logo.png")}
            alt="AVS Logo"
          />
          <img
            className="max-h-24 mx-6 my-4"
            src={require("../../assets/images/customers/avt.png")}
            alt="AVT logo"
          />
          <img
            className="max-h-24 mx-6"
            src={require("../../assets/images/customers/thaikatu.png")}
            alt="Thaikatu logo"
          />

          <img
            className="max-h-24 mx-6"
            src={require("../../assets/images/customers/duropet.png")}
            alt="Duropet logo"
          />
          <img
            className="max-h-24 mx-6"
            src={require("../../assets/images/customers/klf.png")}
            alt="KLF logo"
          />
          <img
            className="max-h-16 mx-4"
            src={require("../../assets/images/customers/Blu-Industries_Logo.png")}
            alt="BLU Logo"
          />
        </div>
      </div>
    </div>
  );
};
export default CustomerBanner;
